import { getAnswer } from '@/utils/onboardingStorage'
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const girlfriend: AnswerType = {
  emoji: '💕',
  title: 'pages.onboarding.companionStyle.girlfriend',
  value: 'girlfriend',
}

const boyfriend: AnswerType = {
  emoji: '💙',
  title: 'pages.onboarding.companionStyle.boyfriend',
  value: 'boyfriend',
}

const friend: AnswerType = {
  emoji: '🤗',
  title: 'pages.onboarding.companionStyle.friend',
  value: 'friend',
}

const open: AnswerType = {
  emoji: '✨',
  title: 'pages.onboarding.companionStyle.open',
  value: 'open',
}

export default function CompanionStyleQuestionPage() {
  // Adapt option order to the user's gender: lead with the most likely
  // romantic match, keep all options available.
  const gender = getAnswer('gender')?.answer_key
  const answers =
    gender === 'female'
      ? [boyfriend, friend, girlfriend, open]
      : [girlfriend, friend, boyfriend, open]

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.companionStyle.title"
      subtitle="pages.onboarding.companionStyle.subtitle"
    />
  )
}
